import {queryPage} from "../../shared/technical/rest/restApi";
import {AxiosInstance} from "axios";
import {Pageable, PagedResult} from "../../shared/technical/rest/pageable";
import {AuditEvent} from "./AuditEvent";

export function getAllAuditEvents(axios: AxiosInstance, pageable: Pageable, params?: string): Promise<PagedResult<AuditEvent>> {
  return queryPage(axios, 'audit-events', pageable, params)
}
